import React from "react";

const OPTIONS = [
  { id: "list", label: "List view" },
  { id: "map", label: "Map view" },
];

const INACTIVE_GRADIENT =
  "linear-gradient(84.86deg, #0031E6 0%, #0036FC 49.57%, #2050FF 100%)";

export const MobileViewToggle = ({ value, onChange }) => (
  <div
    role="tablist"
    className="pointer-events-auto flex w-full rounded-none shadow-lg"
  >
    {OPTIONS.map((option, index) => {
      const isActive = value === option.id;
      const cornerClasses = index === 0 ? "rounded-l-[3px]" : "rounded-r-[3px]";
      return (
        <button
          key={option.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          onClick={() => onChange(option.id)}
          className={`flex-1 ${cornerClasses} px-7 py-1.5 text-[0.8125rem] font-semibold tracking-wide text-white transition${isActive ? " border-[0.5px] border-white" : ""}`}
          style={{ background: isActive ? "#000000" : INACTIVE_GRADIENT }}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);
